import React from 'react';
import { Select } from 'antd';

const items = [
  {
    initials: 'crm',
    name: 'Conselho Regional de Medicina'
  },
  {
    initials: 'crp',
    name: 'Conselho Regional de Psicologia'
  },
  {
    initials: 'crefono',
    name: 'Conselho Regional de Fonoaudiologia'
  },
  {
    initials: 'crefito',
    name: 'Conselho Regional de Fisioterapia e Terapia Ocupacional'
  },
  {
    initials: 'crn',
    name: 'Conselho Regional de Nutricionistas'
  },
  {
    initials: 'cro',
    name: 'Conselho Regional de Odontologia'
  },
  {
    initials: 'coren',
    name: 'Conselho Regional de Enfermagem'
  }
];

const SelectProfessionalRegistrationTypes = (props) => {
  return (
    <Select {...props} dropdownMatchSelectWidth={false}>
      {items.map(({ initials, name }) => (
        <Select.Option key={initials} value={initials}>
          {`${initials.toUpperCase()} - ${name}`}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectProfessionalRegistrationTypes;
